import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "VIII. Specific Health Assessment / 特定健康診断", -1)
const _hoisted_3 = { class: "w-full mb-2 lg:mb-0 lg:pr-10" }
const _hoisted_4 = ["start"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "w-full mt-2.5" }
const _hoisted_8 = { class: "flex lg:flex-row flex-col lg:items-center justify-between gap-2.5" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}

import RadioGroup from '@/components/inputs/RadioGroup.vue';
import { onMounted, ref } from 'vue';
import MedicalService from '@/classes/MedicalService';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecificHealthAssessment',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)

const getOptions = (index:number): any => {
    switch (index) {
        case 5:
            return [
                { id: 'Fast', label: 'Fast / 早い', value: 'Fast'},
                { id: 'Slow', label: 'Slow / 遅い', value: 'Slow'},
                { id: 'Normal', label: 'Normal / ふつう', value: 'Normal'},
            ];
        case 9:
            return [
                { id: 'frequency-everyday', label: 'Everyday / 毎日', value: 'Everyday'},
                { id: 'frequency-rarely', label: 'Rarely / ほとんど飲まない（飲めない）', value: 'Rarely'},
                { id: 'frequency-occasionally', label: 'Occasionally / ときどき', value: 'Occasionally'},
            ];
        case 10:
            return [
                { id: 'volume-less-than-500', label: 'Less than 500ml of beer/ビール500ml未満', value: 'Less than 500ml of beer'},
                { id: 'volume-500-to-1000', label: '500ml to less than 1 1liter of beer/ビール500ml以上1L未満', value: '500ml to less than 1 1liter of beer'},
                { id: 'volume-1000-to-1500', label: '1 liter to less than 1.5 liters of beer/ビール1L以上1.5L未満', value: '1 liter to less than 1.5 liters of beer'},
                { id: 'volume-1500-or-more', label: '1.5 liters or more of beer/ビール1.5L以上', value: '1.5 liters or more of beer'},
            ];
        default:
            return [
                { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                { id: 'no', label: 'No/いいえ', value: 'No'},
            ];
    }
}

onMounted(() => {
    // console.log(item.value.length);
    // if(item.value.length <= 0){
    //     item.value = formValues;
    // }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (question) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "pl-5 mb-6",
        key: question.index
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ol", {
            class: "list-decimal",
            start: question.index+1
          }, [
            _createElementVNode("li", null, [
              _createElementVNode("p", {
                innerHTML: question.description
              }, null, 8, _hoisted_5)
            ])
          ], 8, _hoisted_4),
          (question.jpnlabel)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "text-xs",
                innerHTML: question.jpnlabel
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(RadioGroup, {
              "custom-class": "w-1/2",
              name: question.label,
              isDisabled: __props.disableInputs,
              modelValue: question.status,
              "onUpdate:modelValue": ($event: any) => ((question.status) = $event),
              options: getOptions(question.index),
              errors: __props.errors[`specific_health_assessment.${question.index}.status`]
            }, null, 8, ["name", "isDisabled", "modelValue", "onUpdate:modelValue", "options", "errors"])
          ]),
          (__props.errors[`specific_health_assessment.${question.index}.status`])
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.errors[`specific_health_assessment.${question.index}.status`][0]), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})